import React, { ComponentType } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbLink } from '@guildeducationinc/recess';
import styles from './Breadcrumb.module.scss';

interface Props {
	currentPage: string;
}

export const Breadcrumb: React.FC<Props> = ({ currentPage }) => {
	const location = useLocation();
	const history = useHistory();

	return (
		<Breadcrumbs className={styles.breadcrumbs}>
			{location.state &&
			typeof location.state === 'object' &&
			location.state !== null &&
			'fromGuildCatalog' in location.state ? (
				<BreadcrumbLink className={styles.breadcrumbLink} key='base-url' onClick={history.goBack}>
					Programs
				</BreadcrumbLink>
			) : (
				<BreadcrumbLink
					className={styles.breadcrumbLink}
					component={Link as unknown as ComponentType}
					key='base-url'
					to='/'
				>
					Programs
				</BreadcrumbLink>
			)}
			<div className={styles.breadcrumbLinkCurrent}>
				<BreadcrumbLink current>{currentPage}</BreadcrumbLink>
			</div>
		</Breadcrumbs>
	);
};
